import React, { useEffect, useState } from "react";
import { withTranslation, Trans } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import Select, {components} from "react-select";

import { searchApplication } from "../../services/utilities";
import { SearchContext } from "../searchContext";
import { SettingsContext } from "../settingsContext";
import { dataServices } from "../../services/dataServices";
import FiltersModal from "./FilterModel";
import {
  IconBatch,
  IconStar,
  IconBell,
  IconExclamation,
  IconExrrorExclamatory,
} from "../icons";

/**
 * Component to render search result
 * @param {*} props
 * @returns render search result
 */
function SearchResult(props) {
  const { t, i18n, sortOrderOptions, fetchProducts, setIsFilterApply, isFilterApply, setSelectedFiltersCount, selectedFiltersCount,
    states,
    setStates,
    categories,
    setCategories,
    activeIngredients,
    setActiveIngredients,
    companies,
    setCompanies,
    marketLabels,
    setMarketLabels} = props;

  const searchContext = React.useContext(SearchContext);

  const appState = searchContext.appState;

  let details = navigator.userAgent;

  let regexp = /android|iphone/i;

  let isMobileDevice = regexp.test(details);

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  useEffect(() => {
    const stored = sessionStorage.getItem("filtersSelected");
    let count =0;
    if(stored)
    {
        var filters= JSON.parse(stored);
        count=(filters.state?.length > 0 ? 1 : 0) +
        (filters.activeIngredient?.length > 0 ? 1 : 0) +
        (filters.category?.length > 0 ? 1 : 0) +
        (filters.company?.length > 0 ? 1 : 0) +
        (filters.marketLabel?.length > 0 ? 1 : 0)

    }
    setSelectedFiltersCount(count);
    
    if (count > 0) {
      setIsFilterApply(true);
    }
  }, []);
  
  const [isHovered, setIsHovered] = useState(false);

  const SortIcon = ({ size = 16, style = {} }) => (
    <svg width="20" height="20" viewBox="0 0 32 32" fill="none">
      <path d="M4 22.6667V25.3333H12V22.6667H4ZM4 6.66667V9.33333H17.3333V6.66667H4ZM17.3333 28V25.3333H28V22.6667H17.3333V20H14.6667V28H17.3333ZM9.33333 12V14.6667H4V17.3333H9.33333V20H12V12H9.33333ZM28 17.3333V14.6667H14.6667V17.3333H28ZM20 12H22.6667V9.33333H28V6.66667H22.6667V4H20V12Z" fill="black"/>
    </svg>

  );
  // Show icon only with placeholder
  const CustomPlaceholder = (props) => (
    <components.Placeholder {...props}>
      {props.children} <SortIcon />
    </components.Placeholder>
  );

  // No icon when selected — default SingleValue
  const CustomSingleValue = (props) => (
    <components.SingleValue {...props}>{props.children}</components.SingleValue>
  );

  // Optional dropdown indicator (no icon)
  const CustomDropdownIndicator = (props) => (
    <components.DropdownIndicator {...props} />
  );
  //Get the settings from context
  const settings = React.useContext(SettingsContext);
  
    const start = appState.pageSize
    ? (appState.currentPage - 1) * appState.pageSize + 1
    : 1;
  const end = Math.min(
    appState.currentPage * appState.pageSize,
    appState.totalCount
  );

  var result =
    searchContext?.appState?.result?.length > 0
      ? searchContext?.appState?.result
      : [];

  /**
   * Event listner for sort drop down change
   * @param {*} order
   */
  const sortOrderChange = (order) => {
    fetchProducts(
      1,
      appState?.selectedFilters?.activeIngredient,
      appState?.selectedFilters?.state,
      order,
      appState?.selectedFilters?.company,
      appState?.selectedFilters?.category,
      appState?.selectedFilters?.marketLabel,

    );
  };

  /**
   * Event listner for active ingredient filter change
   * @param {*} selected active ingredient
   */

  /**
   * Event listner for supported state filter change
   * @param {*} selected active ingredient
   */

  /**
   * Update URL when filtered by active ingredients or sorted
   * @param {object} newState
   */

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    // scroll to the result once its displayed on first load of page one time
    // added 10 milliseconds delay as on first load of page - scrolling is not happening exactly at result count element
    // could be because delay in loading filter element.
    setTimeout(() => {
      var offset = 0;
      var customcontainers =
        document.getElementsByClassName("custom-container");
      if (customcontainers.length) {
        offset =
          customcontainers.length === 2
            ? customcontainers[1].getBoundingClientRect().height
            : customcontainers[0].getBoundingClientRect().height;
      }

      if (!offset) {
        var mobileHeader = document.getElementsByClassName(
          "mobile-header-inner"
        );
        if (mobileHeader.length) {
          offset = mobileHeader[0]
            .querySelector(".container")
            .getBoundingClientRect().height;
        }
      }

      const section = document.querySelector(".result-count");
      if (section) {
        var brect = section.getBoundingClientRect();
        var scrollOption = {
          top: brect.top - offset + document.documentElement.scrollTop - 16,
          left: 0,
          behavior: "smooth",
        };
        window.scrollTo(scrollOption);
      }
    }, 10);
  }, []);

  //Passing search information to product details
  let searchData = {
    occupation: appState?.occupation?.label,
    occupation_en: appState?.occupation?.label_en,
    crop_id: appState?.crop?.value,
    crop: appState?.crop?.label,
    crop_en: appState?.crop?.label_en,
    pest_id: appState?.pest?.value,
    pest: appState?.pest?.label,
    pest_en: appState?.pest?.label_en,
    result_count: appState.result?.length ?? 0,
  };

  const emptyFilters = {
    state: [],
    category: [],
    activeIngredient: [],
    company: [],
    marketLabel: []
  };
  

  const fetchFilteredData = async (selectedFilters) => {
      try {
        const crop = appState.crop?.value ?? '';
        const pest = appState.pest?.value ?? '';
  
        const supportedIngredient = (selectedFilters.activeIngredient.length > 0) ? selectedFilters.activeIngredient.map(s => s.value) : [];
        const supportedStates = (selectedFilters.state.length > 0) ? selectedFilters.state.map(s => s.value) : [];
        const supportedCompany = (selectedFilters.company.length > 0) ? selectedFilters.company.map(s => s.value) : [];
        const supportedCategory = (selectedFilters.category.length > 0) ? selectedFilters.category.map(s => s.value) : [];
        const supportedMarketLabel = (selectedFilters.marketLabel.length > 0) ? selectedFilters.marketLabel.map(s => s.value) : []; // Corrected typo
  
        // Filter object
        const filterObject = {
          activeIngredients: supportedIngredient,
          states: supportedStates,
          company: supportedCompany,
          category: supportedCategory,
          marketLabel: supportedMarketLabel, // Corrected typo
        };
  
        const filterString = JSON.stringify(filterObject);
  
        const response = await dataServices.getProducts(
          appState.country,
          settings.getlng(), // Make sure this is a function call
          crop,
          pest,
          "",
          0,
          0,
          settings,
          filterString,
          "", // Use default sorting for filter data
          "product"
        );
  
        if (response.status === 200) {
          const data = response.data.filters; // Fix: Extract JSON data
        return data;
        } else {
          console.log(["SearchForm:getProducts", response]);
        }
      } catch (error) {
        console.error("Error fetching filter data:", error);
      }
    };

  //Whether to show missing product notice for the country
  let showProductMissingNotice = false;
  if (settings.country_code_missing_product) {
    let countryCodes = settings.country_code_missing_product
      .toLowerCase()
      .split(",")
      .filter((x) => {
        return x.toLowerCase() === appState.country.toLowerCase();
      });

    showProductMissingNotice = countryCodes.length > 0;
  }

  const countrySelected = (code) => {
    var selected = appState.countries.filter((item) => item.value === code);

    if (selected && selected.length > 0) {
      return selected[0].label;
    }

    return null;
  };

  const queryParam = searchApplication.historyHelper.queryParam(
    useLocation().search
  );

  const cropSelected = () => {
    if (queryParam.crop) {
      var selected = appState.crops.filter(
        (item) => item.value === queryParam.crop
      );

      if (selected && selected.length > 0) {
        return selected[0].label;
      } else if (appState.crop) {
        return appState.crop.label;
      }
    }
    return null;
  };

  const pestSelected = () => {
    var selected = appState.pests.filter(
      (item) => item.value === queryParam.pest
    );

    if (selected && selected.length > 0) {
      return selected[0].label;
    } else if (appState.pest) {
      return appState.pest.label;
    }

    return null;
  };
 
  //When search not performed or search with 0 result
  if (result === null || result.length === 0) {
    return (
      <section data-testid="result-wrapper">
        <div className="container"></div>
      </section>
    );
  } else {
return (
      <section data-testid="result-wrapper">
        <div className={isMobileDevice ? "container s-r pt-2" : "container pt-4 s-r"}>
          <div className="row">
            <div className={isMobileDevice ? "col-sm-12 information-container ps-2 pe-2" : "col-sm-12 information-container"}>
              <IconBatch className="me-1 align-middle" />
              <div className="information">
                <h4
                  className={isMobileDevice ? "fw-normal lh-sm mb-0" : "fw-normal lh-sm"}
                  dangerouslySetInnerHTML={{
                    __html: t(
                      "ProductRegistration" +
                      searchApplication.removeWhiteSpace(
                        appState.countryName.split(" - ")[0]
                      )
                    ),
                  }}
                ></h4>
              </div>
            </div>
            {!settings.standalone && t("Signuptext") !== "Signuptext" && (
              <div className={isMobileDevice ? "col-sm-12 d-flex my-2" : "col-sm-12 d-flex my-3"}>
                <IconBell className="icon-size me-1 align-middle" />
                <div className="information">
                  <h4
                    className="fw-normal lh-sm m-0"
                    dangerouslySetInnerHTML={{
                      __html: t("Signuptext"),
                    }}
                  ></h4>
                </div>
              </div>
            )}
            <div className="col-sm-12">      
              <div className="d-flex flex-wrap justify-content-between align-items-center mt-0">
                <h4 className={isMobileDevice ? "m-1" : "mt-4 mb-4"}>
                  {RenderResultCount(settings, start, end, appState, t)}
                  {
                  <span className="badge rounded-pill bg-cabi text-dark fs-6 me-1 mb-2 ms-1 mt-2">
                    {countrySelected(appState.country)}
                  </span>
                  }
                  {cropSelected() ? (
                    <span className="badge rounded-pill fs-6 bg-cabi text-dark me-1">
                      {cropSelected()}
                    </span>
                  ) : null}
                  {pestSelected() ? (
                    <span className="badge rounded-pill fs-6 bg-cabi text-dark ">
                      {pestSelected()}
                    </span>
                  ) : null}
                </h4>

                <div
                  className={`d-flex ${isMobileDevice ? "flex-row" : "flex-wrap"} align-items-center justify-content-between gap-2 mt-3`}
                  style={{ width: isMobileDevice ? "100%" : "auto" }}>
                  {/* Filters Button */}
                  <button
                    type="button"
                    className="btn d-flex align-items-center justify-content-center gap-2"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={async () => {
                      if (selectedFiltersCount <= 0) {
                        const data = await fetchFilteredData(emptyFilters);
                        setStates(data.states || []);
                        setCategories(data.categories || []);
                        setActiveIngredients(data.activeIngredients || []);
                        setCompanies(data.companies || []);
                        setMarketLabels(data.marketLabels || []);
                      }
                      setIsFilterModalOpen(true);
                    }}
                    style={{
                      border: selectedFiltersCount > 0
                      ? `3px solid ${isHovered ? "#a0a9b2" : "#ced4da"}`
                      : `1px solid ${isHovered ? "#adb5bd" : "#dee2e6"}`,
                      padding: "2px 12px",
                      minWidth: isMobileDevice ? "50%" : "150px",
                      height: "32px",
                      minHeight: "32px", 
                      backgroundColor: "white",
                      fontWeight: 600,
                      fontSize: "16px",
                      borderRadius: "0px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      lineHeight: "normal",
                      cursor: "pointer",
                    }}
                  >
                    <span  style={{ color: "inherit" }}><Trans>FilterBy</Trans></span>
                    {selectedFiltersCount > 0 ? (
                      <span
                        style={{
                          backgroundColor: "green",
                          color: "white",
                          borderRadius: "50%",
                          width: "20px",
                          height: "20px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                          fontWeight: "bold"
                        }}
                      >
                        {selectedFiltersCount}
                      </span>
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 32 32" fill="none">
                        <path d="M9.34001 7.99992H22.6733L15.9933 16.3999L9.34001 7.99992ZM5.67334 7.47992C8.36668 10.9333 13.34 17.3333 13.34 17.3333V25.3333C13.34 26.0666 13.94 26.6666 14.6733 26.6666H17.34C18.0733 26.6666 18.6733 26.0666 18.6733 25.3333V17.3333C18.6733 17.3333 23.6333 10.9333 26.3267 7.47992C27.0067 6.59992 26.38 5.33325 25.2733 5.33325H6.72668C5.62001 5.33325 4.99334 6.59992 5.67334 7.47992Z" fill="black"/>
                      </svg>
                    )}
                  </button>

                  {/* Sort By Dropdown */}
                  <div style={{ minWidth: isMobileDevice ? "50%" : "150px", width: isMobileDevice ? "50%" : "auto" }}>

                    <Select
                      classNamePrefix="select-react"
                      isClearable={false}
                      isRtl={searchApplication.isRTL(i18n)}
                      isSearchable={false}
                      placeholder={t("SortBy")}
                      options={sortOrderOptions}
                      value={appState.sortOrder}
                      onChange={sortOrderChange}
                      components={{
                        Placeholder: CustomPlaceholder,
                        SingleValue: CustomSingleValue,
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          borderColor: "#ced4da", 
                          padding: "0px 6px",
                          height: "32px",
                          minHeight: "32px",
                          backgroundColor: "white",
                          fontWeight: 500,
                          boxShadow: "none",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: 0,
                          "&:hover": {
                            borderColor: "#a0a9b2"
                          }
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: "black",
                          fontWeight: 500,
                          fontSize: "16px",
                          justifyContent: "center",
                          textAlign: "center",
                          width: "100%"
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          padding: "0px",
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center"
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          fontWeight: 500,
                          fontSize: "16px",
                          textAlign: "center",
                          width: "100%"
                        }),
                        dropdownIndicator: (provided) => ({
                          display: "none"
                        }),
                        indicatorSeparator: () => ({
                          display: "none"
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999
                        })
                      }}
                    />
                  </div>
                  </div>

                  {/* Filters Modal */}
                  {isFilterModalOpen && (
                    <FiltersModal
                      isOpen={isFilterModalOpen}
                      setIsOpen={setIsFilterModalOpen}
                      countryName={appState.countryName}
                      states={states}
                      setStates={setStates}
                      categories={categories}
                      setCategories={setCategories}
                      activeIngredients={activeIngredients}
                      setActiveIngredients={setActiveIngredients}
                      companies={companies}
                      setCompanies={setCompanies}
                      marketLabels={marketLabels}
                      setMarketLabels={setMarketLabels}
                      fetchFilteredData={fetchFilteredData}
                      setIsFilterApply={setIsFilterApply}
                      isFilterApply={isFilterApply}
                      onApplyFilters={(filters) => {
                        setIsFilterApply(true);
                        fetchProducts(1, filters.activeIngredient, filters.state, null, filters.company, filters.category, filters.marketLabel);
                        setIsFilterModalOpen(false);
                      }}
                      onClearFilters={() => {
                        if(isFilterApply){
                          fetchProducts(1, "", "", null, "", "", "");
                        }
                      }}
                      setSelectedFiltersCount={setSelectedFiltersCount}
                      t={t}
                      i18n={i18n}
                    />
                  )}
                </div>
            </div>
          </div>
          <div className="row s-r">
            {showProductMissingNotice ? (
              <div className="col-sm-12 pb-4 d-flex align-items-start">
                <div className="me-1">
                  <IconExclamation width="20px" />
                </div>
                <div
                  className="fs-5 fw-bold pt-1"
                  dangerouslySetInnerHTML={{ __html: t("ProductMissingLabel") }}
                ></div>
              </div>
            ) : null}
        <div className="col-sm-12">
          <div className="row is-flex">
            {result.map((item) => (
              <RenderProductInfo
                key={item.product.id}
                item={item}
                appState={appState}
                settings={settings}
                searchData={searchData}
              />
            ))}
          </div>
        </div>
      </div>
        </div>
      </section>
    );
  }
}

/**
 * Component to render product information
 * @param {*} param0
 * @returns
 */
function RenderProductInfo({ item, appState, settings, searchData }) {
  //Create a list with new property display name
  let activeIngredients = (item.product.activeIngredient ?? []).map((i) => {
    return { ...i, displayName: searchApplication.getName(i) };
  });
  const urlLogo = item.product?.endorsementDetails?.endorsementData?.map((el, i) => el.logoUrl);
  const endorsements = item.product?.endorsementDetails?.endorsementData || []; 
  //Sort the list
  activeIngredients = activeIngredients.sort(
    searchApplication.sortOnAsc("displayName")
  );

  let calculatePadding = (item) => {
    let count = 0;
    if (item.green) count += item.green.length;
    if (item.amber) count += item.amber.length;

    return 100 * count + "px";
  };

  const createProductURL = function (item) {
    const urlParams = new URLSearchParams(window.location.search);
    const stateCode = urlParams.get("state");
    const name = item.product.nameEN;
    const slug = searchApplication.createURLComponentSlug(name);
    const qlng =
      (settings.standalone || appState.showLng) && appState.language
        ? `&lng=${appState.language.value}`
        : "";
    const state = stateCode ? `&state=${stateCode}` : "";
    return `${settings.productdetails_url}/${slug}-${item.product.id}/?country=${appState.country}${qlng}${state}`;
  };

  const handleClick = (e) => {
    sessionStorage.setItem("scrollPosition", window.pageYOffset);
  };
  return (
    <div className="col-xs-1 col-md-6 col-lg-4 d-flex">
      <Link
        to={{
          pathname: createProductURL(item),
          state: { searchData: searchData, searchState: appState },
        }}
        style={{ paddingBottom: calculatePadding(item) }}
        className={
          item.product.authorizeStatus
            ? `mt-4 result-card rounded-3 text-decoration-none w-100 position-relative bg-white ${item.product.authorizeStatus.toLowerCase()}`
            : "result-card rounded-3 text-decoration-none w-100 position-relative bg-white"
        }
        data-id={item.product.id}
        onClick={handleClick}
      >
        {(typeof item.product.goldStar === "string"
          ? item.product.goldStar.toLowerCase() === "true"
          : Boolean(item.product.goldStar)) ? (
          <span className="sponsored d-flex d-block p-1 justify-content-center align-items-center">
            <IconStar className="align-middle me-1" />
            <span className="fw-bold align-middle">
              <Trans>PartnerProduct</Trans>
            </span>
          </span>
        ) : (
          <span className="sponsored d-flex d-block p-1 justify-content-center align-items-center bg-secondary">
            <span className="fw-bold align-middle text-dark">
              <Trans>ProductTileBanner</Trans>
            </span>
          </span>
        )}

        <div className="pt-2 ps-4 d-flex align-items-center pe-4">
          <div
            className={
              (typeof item.product.goldStar === "string"
                ? item.product.goldStar.toLowerCase() === "true"
                : Boolean(item.product.goldStar))
                ? "category text-center p-2 me-2"
                : "category text-center p-2 round me-2"
            }
          >
            {item.product.category && item.product.category.length > 0 ? (
              item.product.category.map((categoryItem, index) => (
                <img
                  key={index}
                  alt={categoryItem.name}
                  src={`${settings.category_icons_folder}${searchApplication.createCategoryIconName(
                    categoryItem.nameEN
                  )}`}
                />
              ))
            ) : null}
          </div>
          <h4 className="product-name">{item?.displayName}</h4>
        </div>

        <div className="ps-4 pe-4 pt-2 pb-2 fs-5">

          <label className="category-label fw-bold mb-0">
            {searchApplication.getName(item.product.category)}
          </label>
          <ul className="active-ingredient p-0 pt-1 pb-2 mb-2 ">
            <label>
              <Trans>Activeingredient</Trans>
            </label>

            {activeIngredients.slice(0, 2).map((aingredient, i) => (
              <li className="ms-3" data-id={aingredient.id} key={i}>
                {aingredient.displayName}
              </li>
            ))}

            {activeIngredients.length > 3 && (
              <li className="ms-3 more" data-id="more">
                <Trans>AIMoreText</Trans>
              </li>
            )}
          </ul>
          {Array.isArray(item.company) && item.company.length > 0 && (
            <ul className="company p-0">
              {item.company.map((companyItem, index) => (
                <li key={index}>
                  <RenderRegistrant item={companyItem?.registrant} />
                  <RenderManufacturer item={companyItem?.manufacturer} />
                  <RenderDistributors items={companyItem?.distributors} />
                </li>
              ))}
            </ul>
          )}
        </div>
        {(item.green || item.amber || item.product?.isOMRIProduct) && (
          <div className="standards ps-4 pe-4 pt-3 position-absolute w-100  d-flex justify-content-between align-items-center">
            {item.product?.isOMRIProduct ? (
              <div className="endorsment d-inline-flex  p-0 mb-2 align-items-center me-2">
                <img style={{ width: '75.58px', height: '41.99px', marginRight: '5px', }}
                  src={item.product?.omriLogoUrl}
                  alt={item.product?.endorsementName}
                />
                {urlLogo?.map((url, index) => (
                  <img
                    key={index}
                    style={{ height: '42px', marginRight: '8px', width: '82px' }}
                    src={url}
                    alt={`Logo ${index + 1}`}
                  />
                ))}

              </div>
            ) : null}
            {item.green &&
              item.green.map((s, i) => (
                <div
                  className="green d-inline-flex p-0 mb-2 align-items-center gap-1 position-relative "
                  key={s.standardBasicData.standardId}
                >

                  <img
                    src={s.standardBasicData.standardLogoURL}
                    alt={s.standardBasicData.standardName}
                    style={{ marginRight: '5px' }}
                  />

                  {urlLogo?.map((url, index) => (
                    <img
                      key={index}
                      style={{ height: '42px', marginRight: '8px', width: '82px' }}
                      src={url}
                      alt={`Logo ${index + 1}`}
                    />
                  ))}
                  <span className="fs-5">
                    <Trans></Trans>
                  </span>
                </div>
              ))}
            {item.amber &&
              item.amber.map((s) => (
                <div
                  key={s.standardBasicData.standardId}
                  className="ambar d-inline-flex p-0 mb-2 align-items-center gap-1 position-relative"
                >
                  <img
                    src={s.standardBasicData.standardLogoURL}
                    alt={s.standardBasicData.standardName}
                    style={{ marginRight: '5px' }}
                  />
                  {urlLogo?.map((url, index) => (
                    <img
                      key={index}
                      style={{ height: '42px', marginRight: '8px', width: '82px' }}
                      src={url}
                      alt={`Logo ${index + 1}`}
                    />
                  ))}
                  <IconExrrorExclamatory
                    className="position-absolute"
                    fill={"#cd4400"}
                  />

                  <span className="fs-5 text-dark">
                    <Trans>
                      {(s.standardBasicData.productDetailAmberLogoLabel !== "RiskMitigationRequired" && s.standardBasicData.productDetailAmberLogoLabel !== "PermittedForUse") ? s.standardBasicData.productDetailAmberLogoLabel : ""}
                    </Trans>
                  </span>


                </div>
              ))}
            <button className="btn moreInfo-btn"><Trans>MoreInfoButton</Trans></button>
          </div>
        )}
        {!item.green && !item.amber && endorsements.length > 0 && (
          <div className="ps-4 pe-4 pt-3 pb-3 d-flex justify-content-between align-items-center flex-wrap">
            <div className="d-flex align-items-center flex-wrap">
              {urlLogo?.map((url, index) => (
                <img
                  key={index}
                  style={{
                    height: '42px',
                    marginRight: '8px',
                    width: '82px'
                  }}
                  src={url}
                  alt={`Logo ${index + 1}`}
                />
              ))}
            </div>

    <button className="btn moreInfo-btn">
      <Trans>More info</Trans>
    </button>
  </div>
)}


        {!item.green && !item.amber && endorsements.length <= 0 && <div className="pb-3 ps-4  pe-4 pt-3 d-flex justify-content-end"><button className="btn moreInfo-btn"><Trans>More info</Trans></button></div>}

      </Link>

    </div>
  );
}

/**
 * Component to render distributors
 * @param {Array} param0
 * @returns
 */
function RenderDistributors({ items }) {
  return Array.isArray(items) && items.length > 0 ? (
    <li className="distributors pb-2">
      <ul className="p-0">
        <label >
          <Trans>Distributors</Trans> :
        </label>
        {items.map((item) => (
          <li className="d-inline" data-id={item.id} key={item.id}>
            <span className="fs-8"> {searchApplication.getName(item)}</span>
          </li>
        ))}
      </ul>
    </li>
  ) : null;
}

/**
 * Component to render registrant
 * @param {*} param0
 * @returns
 */
function RenderRegistrant({ item }) {
  return item ? (
    <li className="registrant pb-2" data-id={item.id}>
      <span >
        <Trans>Registrant</Trans> {searchApplication.getName(item)}
      </span>
    </li>
  ) : null;
}

/**
 * Component to render manufaturer
 * @param {*} param0
 * @returns
 */
function RenderManufacturer({ item }) {
  return item ? (
    <li className="manufacturer pb-2" data-id={item.id}>
      <span >
        <Trans>Manufacturer</Trans>: {searchApplication.getName(item)}
      </span>
    </li>
  ) : null;
}

function RenderResultCount(settings, start, end, appState, t) {
  let key = "ShowingText";
  let template = t(key);
  if (template === key) {
    template = "Showing {0} - {1} of {2}"; //Translation not available
  }

  let values = [
    start ?? 1,
    settings?.is_pagination ? end : appState.totalCount,
    appState.totalCount,
  ];

  let result = template.replace(/{(\d+)}/g, (_, index) => values[index]);
  return <span className="ms-1">{result}</span>;
}

export default withTranslation()(SearchResult);
